<h2>Brand Listing</h2>

<div class="grid">

    <div class="col-8">

        <p-table #dt [columns]="cols" [value]="brands" selectionMode="single" class="wal-table"
            [(selection)]="selectedBrand"  (onRowSelect)="onRowBrandSelect($event)" 
            sortMode="multiple" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]" [rows]="15" >

          <ng-template pTemplate="caption">
              List of Brands
          </ng-template>
          <ng-template pTemplate="header" let-columns>
              <tr>
                    @for (col of columns; track col.field) {
                        <th [pSortableColumn]="col.field"
                            [style.display]="col.display"
                            [style.width]="col.width">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    }
              <th pSortableColumn="accountDataSource" style="width: 8%">Data Source<p-sortIcon field="accountDataSource"></p-sortIcon></th>
              <th pSortableColumn="isActive" style="width: 7%">Active? <p-sortIcon field="isActive"></p-sortIcon></th>
              <!-- <th pSortableColumn="isMamBased" style="width: 8%">MAM Based? <p-sortIcon field="isMamBased"></p-sortIcon></th> -->
            </tr>
              <tr>
                    @for (col of columns; track col.field) {
                        <th [style.width]="col.width" [style.display]="col.display">
                            @switch (col.field) {
                                @case ('brandCode') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('brandName') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('envCode') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @default {
                                }
                            }
                        </th>
                    }                
            </tr>  
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData" class="p-selectable-row p-highlight">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                <td>
                    {{getAccountDataSource(rowData?.brandAttributes)}}
                </td>                  

                <td>
                    <p-tag [value]="rowData.isActive ? 'Y' : 'N'" [severity]="getStatus(rowData.isActive)"></p-tag>
                </td>
                
<!-- 
                <td>
                    @if(getMamBasedValue(rowData?.brandAttributes) != undefined) {
                        <p-tag [value]="getMamBasedValue(rowData?.brandAttributes)" 
                            [severity]="getMamBasedSeverity(rowData?.brandAttributes)">
                        </p-tag>
                    }
                </td>                  
 -->
            </tr>
          </ng-template>

        </p-table> 
      
    </div>

    <div class="col-2" id="idSpinner" [hidden]="isSpinnerHidden">
        <div class="loader"></div>  
    </div>

</div>    

    <div class="grid">
        <div class="col-8" style="background-color: #7b95a3; text-align: left;"> 

            <div class="grid">
                <div class="col-1"></div>
                <div class="field grid">
                    <label for="emailAddress" class="col-fixed label" style="width: 15em">Receiver's Email: </label>
                </div>
                <div class="col-3 group">
                    <textarea [rows]="1" [cols]="60" pTextarea [autoResize]="autoResize" id="emailAddress" 
                        [(ngModel)]="emailAddress" style="width: 100%;"></textarea>
                </div>

                <div class="col-2 group">
                    <p-button type="button" label="Get Enrolled Accounts" (click)="onEnrolledAccountsClick($event)"
                        pTooltip="Generate an email with a list of enrolled account numbers for the selected brand"
                        styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left">
                    </p-button>
                </div> 
                <div class="col-2 group">
                    <p-button type="button" label="Account Data Extract" (click)="onAccountDataExtract($event)"
                        *ngIf="isAccountDataShown"
                        pTooltip="Generate an email with an extract of enrolled accounts, including user specified data elements, for the selected brand"
                        styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left">
                    </p-button>
                </div> 
                <div class="col-2 group">
                    <p-button type="button" label="Remove Brand" (click)="onRemoveBrandClick($event)"
                        *ngIf="isRemoveBrandShown"
                        pTooltip="Completely delete the selected brand, including all its configuration and customer data"
                        styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left">
                    </p-button>
                </div> 
    
            </div>                
    
        </div>
    </div> 


<!-- </div> -->

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="brand-listing"></p-confirmDialog>

<p-dialog appendTo="body" header="Account Data Extract" [(visible)]="displayDialog" [focusOnShow]="false" 
        [responsive]="true" styleClass="wal-dialog"
        showEffect="fade" [modal]="true"  [style]="{width: '30%'}">

        <p-card header="Brand Level Variables" subheader="" styleClass="ui-card-light" >

            <p-pickList [source]="availableVariables" [target]="selectedVariables" sourceHeader="Available" targetHeader="Selected" 
                    [sourceStyle]="{'height':'25rem'}" [targetStyle]="{'height':'25rem'}"
                    styleClass="ui-card-light" filterBy="tags"
                    [responsive]="true" [dragdrop]="true" [showSourceControls]="false" [showTargetControls]="true">
                <ng-template let-variable pTemplate="item">
                <div class="ui-helper-clearfix">
                    <div>{{variable.label}}</div>
                </div>
                </ng-template>
            </p-pickList>

        </p-card>


        <ng-template #footer>
            <div class="footer-actions">
                <p-button type="button" label="Submit" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onSubmitAccountExtract()"></p-button>
                <p-button type="button" label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="cancel()"></p-button>
            </div>
        </ng-template>


</p-dialog>

